<template>
  <ul class="timeline">
    <line-item v-for="item in items" :item="item" :key="item.id"></line-item>
  </ul>
</template>

<script>
import LineItem from './item.vue'

export default {
  props: ['items'],

  components: { LineItem },

  events: {
    'delete-item': function() {
      return true // forward to parent
    },
  },
}
</script>

<style lang="sass">
@import '../assets/timeline.sass'
</style>
